import React from 'react'
import CellRenderPercent from './DocPercent'

export const columnPercentRenderer = ({ record, value }) => {
    const {originalData: {isItemRow, id, isRootRow, isLane },originalData} = record;

    return <CellRenderPercent record={record} percentDone={value} />
}